import { render, staticRenderFns } from "./WorkflowFormTemplateStakeholderUsersAutoCompletePicker.vue?vue&type=template&id=748125c8&"
import script from "./WorkflowFormTemplateStakeholderUsersAutoCompletePicker.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormTemplateStakeholderUsersAutoCompletePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports